import React, { Component } from "react";
import "./Login.css";
import axios from "axios";
import "./Signin.css";
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';

class ResetArea extends Component {
  state = {
    passwords: {
      new_password1: "",
      new_password2: "",
    },
    setSuccess: false,
    validationErrors: [],
    error_list: "",
  };

  get_error_list = () => {
    if(this.state.error_list!==""){

      var error_list = this.state.error_list;
      const errors_str = error_list.split("</li>");
      let errors = [];
      errors_str.forEach(function (item, index) {
        if(item.length!==0){
          errors.push(<li key={index}>{item}</li>);
        }
      });

      return(errors)
    }
  }
  
  validate_fields = () => {
    let errors = "";
    if(this.state.passwords["new_password1"]===""){
      errors = errors + "Please enter password</li>";
      this.setState({error_list: errors});
      return false;
    }
    if(this.state.passwords["new_password2"]===""){
      errors = errors + "Please repeat password</li>";
      this.setState({error_list: errors});
      return false;
    }
    return true;
  }

  reset_password = () => {
    if(!this.validate_fields()){return;}

    const formData = new FormData();
    formData.append("new_password1", this.state.passwords["new_password1"]);
    formData.append("new_password2", this.state.passwords["new_password2"]);
    formData.append("csrfmiddlewaretoken", this.props.csrftoken);

    axios
      .post(
        `${this.props.baseUrl}/api/reset/${this.props.params.uid}/set-password/`,
        formData,
        {
          withCredentials: true,
        }
      )
      .then((response) => {

        if (response.data.includes("Password reset complete")) {
          this.setState({error_list: ""});
          this.setState({ setSuccess: true });
        } else {
          const data = response.data;
          var error_list_index = data.indexOf('<ul class="errorlist">');
          var error_list = data.substring(error_list_index);
          error_list_index = error_list.indexOf("</ul>");
          error_list = error_list.substring(0, error_list_index);
          error_list = error_list.replace("<ul class=\"errorlist\">", "");
          error_list = error_list.replace(/<li>/g, "");
          this.setState({error_list: error_list});
        }
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  inputChanged = (event) => {
    const pwds = this.state.passwords;
    pwds[event.target.name] = event.target.value;
    this.setState({ passwords: pwds });
  };

  renderErrors = () => {

    if (this.props.getRegistered()) {
      return (
        <li style={{ color: "rgb(30, 255, 0)" }} key={"registration success"}>
          Registration Successful. Please Sign In
        </li>
      );
    }

    const validationErrors = this.state.validationErrors;

    const error_tags = ["username", "password", "non_field_errors"];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      var msg = "";
      if (error_msg) {
        if (error_tag === "username") {
          msg = "Enter username";
        } else if (error_tag === "password") {
          msg = "Enter password";
        } else {
          msg = "The info doesn't match our records.\t Please try again.";
        }
        errors.push(
          <li style={{ color: "red" }} key={error_tags[i]}>
            {msg}
          </li>
        );
      }
    }

    return errors;
  };

  render() {
    return (
      <div className="input_area">
        <div className="title_area">
          <h1>Reset Password</h1>
        </div>
        {this.state.setSuccess ? (
          <>
            <label>
              Your password has been reset.
              <br />
              <br />
              You may sign in now
              <Link to={this.props.baseDir}> here</Link>.
            </label>
          </>
        ) : (
          <>
            <label>
              New Password:
              <br />
              <input
                type="password"
                name="new_password1"
                value={this.state.new_password1}
                onChange={this.inputChanged}
              />
            </label>
            <br />
            <label>
              Repeat Password:
              <br />
              <input
                type="password"
                name="new_password2"
                value={this.state.new_password2}
                onChange={this.inputChanged}
              />
            </label>

            <button
              className="login_button"
              onClick={() => {
                this.reset_password();
              }}
            >
              Reset Password
            </button>
            <ul>{this.get_error_list()}</ul>
          </>
        )}
      </div>
    );
  }
}

export default withRouter(ResetArea);
